import { JSX } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import React from 'react';

type ImportFn = () => Promise<any>;
interface ComponentState {
  C: JSX.Element | (() => JSX.Element);
}

const lazyLoad = (
  importFn: ImportFn,
  fallback: () => JSX.Element,
  _loaded?: JSX.Element,
): React.FC<any> =>
  // Preact calls components with (props, context, ...hooks) — extra args are invisible to React types
  ((
    props: any,
    context: any,
    [{ C }, set] = useState<ComponentState>({ C: _loaded || fallback }),
    unmounted = useRef(0),
  ) => (
    useEffect(
      () => (
        !_loaded &&
          importFn().then(
            ({ default: comp }) => ((_loaded = comp), unmounted.current || set({ C: comp })),
          ),
        () => (unmounted.current = 1)
      ),
      [set, unmounted],
    ),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    C ? <C {...props} /> : null
  )) as unknown as React.FC<any>;

export { lazyLoad };
